export const genderOptions = [
  { value: "0", label: "Male" },
  { value: "1", label: "Female" },
  { value: "2", label: "Other" },
];
export const parentTypeOptions = [
  { value: "0", label: "Father" },
  { value: "1", label: "Mother" },
  { value: "2", label: "Guardian" },
];

 export const RelationshipType=  [
    { value: 0, label: 'Parent' },
    { value: 1, label: 'Guardian' },
    { value: 2, label: 'Emergency Contact' },
    { value: 3, label: 'Other' }
  ];
   export const RelationshipCategory = [
     { value: 0, label: "Biological Parent" },
     { value: 1, label: "Legal Guardian" },
     { value: 3, label: "Other" },
   ];
export const relationshipToStudentOptions = [
  { value: "0", label: "Father" },
  { value: "1", label: "Mother" },
  { value: "2", label: "Legal Guardian" },
  { value: "3", label: "Grandparent" },
  { value: "4", label: "Uncle" },
  { value: "5", label: "Aunt" },
  { value: "6", label: "Other" },
];

export const religionOptions = [
  { value: "0", label: "Christianity" },
  { value: "1", label: "Islam" },
  { value: "2", label: "Judaism" },
  { value: "3", label: "Buddhism" },
  { value: "4", label: "Hinduism" },
  { value: "5", label: "Other" },
];

export const occupationTypeOptions = [
  { value: "0", label: "Private Sector Employee" },
  { value: "1", label: "Public Sector Employee" },
  { value: "2", label: "Self Employed" },
  { value: "3", label: "Business" },
  { value: "4", label: "Professional" },
  { value: "5", label: "Retired" },
  { value: "6", label: "Other" },
];

export const phoneTypeOptions = [
  { value: "0", label: "Mobile" },
  { value: "1", label: "Home" },
  { value: "2", label: "Office" },
  { value: "3", label: "Other" },
];
export const PenaltyStatus = [
  { value: 0, label: "Active" },
  { value: 1, label: "Inactive" },
  { value: 2, label: "Expired" },
];
export const PaymentStatus = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Completed" },
  { value: 2, label: "Failed" },
  { value: 3, label: "Refunded" },
  { value: 4, label: "Cancelled" },
  { value: 5, label: "Other" },
];
export const OtpType = [
  { value: 0, label: "Email Verification" },
  { value: 1, label: "Password Reset" },
  { value: 2, label: "Two Factor Auth" },
];
export const IncomeType = [
  { value: 0, label: "Salary" },
  { value: 1, label: "Business" },
  { value: 2, label: "Self Employed" },
  { value: 3, label: "Pension" },
  { value: 4, label: "Investment" },
  { value: 5, label: "Rental" },
  { value: 6, label: "Agriculture" },
  { value: 7, label: "Remittance" },
  { value: 8, label: "Other" },
];
export const IncomeLevel = [
  { value: 0, label: "Low Income" },
  { value: 1, label: "Lower Middle Income" },
  { value: 2, label: "Middle Income" },
  { value: 3, label: "Upper Middle Income" },
  { value: 4, label: "High Income" },
];
export const ApprovalStatus = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Approved" },
  { value: 2, label: "Rejected" },
  { value: 3, label: "Under Review" },
];
export const ApplicationStatus = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Approved" },
  { value: 2, label: "Rejected" },
];
